import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Unauthorized from "../general/Unauthorized";
import Loading from "../general/Loading";

function MenuLaboratorio() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a laboratorio
        const tienePermiso = userdata.up && userdata.up.includes('verLaboratorio');

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);
        setLoggedIn(true);
    }, []);

    // 🔒 PROTECCIÓN DE RUTA
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <Header />
            <Aside activelink="laboratory" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0">Laboratorio</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            
                            {/* Card Nueva Orden */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-custom-dark">
                                    <div className="inner">
                                        <h3>&nbsp;</h3>
                                        <p>Nueva Orden</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-plus"></i>
                                    </div>
                                    <Link to="/crear-orden-laboratorio" className="small-box-footer">
                                        Crear <i className="fas fa-arrow-circle-right"></i>
                                    </Link>
                                </div>
                            </div>

                            {/* Card Listado de Órdenes */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-custom-dark">
                                    <div className="inner">
                                        <h3>&nbsp;</h3>
                                        <p>Listado de Órdenes</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-list"></i>
                                    </div>
                                    <Link to="/listado-ordenes-laboratorio" className="small-box-footer">
                                        Ver Listado <i className="fas fa-arrow-circle-right"></i>
                                    </Link>
                                </div>
                            </div>

                            {/* Card Tipos de Trabajo */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-custom-dark">
                                    <div className="inner">
                                        <h3>&nbsp;</h3>
                                        <p>Administrar Tipos de Trabajo</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-cogs"></i>
                                    </div>
                                    <Link to="/tipos-trabajo-laboratorio" className="small-box-footer">
                                        Administrar <i className="fas fa-arrow-circle-right"></i>
                                    </Link>
                                </div>
                            </div>

                            {/* Card Materiales */}
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-custom-dark">
                                    <div className="inner">
                                        <h3>&nbsp;</h3>
                                        <p>Parametrizar Materiales</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-cubes"></i>
                                    </div>
                                    <Link to="/materiales-laboratorio" className="small-box-footer">
                                        Administrar <i className="fas fa-arrow-circle-right"></i>
                                    </Link>
                                </div>
                            </div>

                        </div>

                        {/* Información adicional */}
                        <div className="row">
                            <div className="col-12">
                                <div className="card card-info card-outline">
                                    <div className="card-header">
                                        <h3 className="card-title"><i className="fas fa-info-circle"></i> Información del Módulo</h3>
                                    </div>
                                    <div className="card-body">
                                        <p><strong>Gestión de Órdenes de Laboratorio</strong></p>
                                        <ul>
                                            <li>Crear órdenes de laboratorio con múltiples trabajos</li>
                                            <li>Asignar profesionales responsables a cada trabajo</li>
                                            <li>Registrar procesos realizados en cada trabajo</li>
                                            <li>Seguimiento de estados: Pendiente, En Proceso, Completada, Entregada</li>
                                            <li>Control de fechas de recepción y entrega estimada</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default MenuLaboratorio;
